import { Capacitor } from '@capacitor/core';
import PrintIcon from '@mui/icons-material/Print';
import { Box, Typography } from '@mui/material';
import List from '@mui/material/List';
import React, { useEffect, useState } from 'react';
import { LANG_TEXT } from '../../../constants/language';
import { useSettingsContext } from '../../../context/SettingsContext';
import usePermission from '../../../hooks/usePermission';
import { useSidebarItems } from '../../../hooks/useSidebarItems';
import { Drawer } from '../../MainLayout/SideBar/SideBar';
import { SidebarItemComponent } from '../../MainLayout/SideBar/SidebarItemComponent';
import { useStyles } from './styles';

function FoodTruckSideBar() {
  const classes = useStyles();
  const { restaurantId, isAstrolabStore } = usePermission();
  const { currentSetting, loading } = useSettingsContext();

  const { staffSidebarItems } = useSidebarItems({});

  const [open, setOpen] = React.useState(true);
  const [expandedItems, setExpandedItems] = useState<{ [key: string]: boolean }>({});

  const isNativeApp =
    typeof Capacitor !== 'undefined' &&
    (typeof (Capacitor as any).isNativePlatform === 'function'
      ? (Capacitor as any).isNativePlatform()
      : typeof (Capacitor as any).getPlatform === 'function'
        ? (Capacitor as any).getPlatform() !== 'web'
        : !!(typeof window !== 'undefined' && (window as any).Capacitor));

  useEffect(() => {
    function handleResize() {
      setOpen(window.innerWidth >= 600);
    }
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleSubMenu = (itemId: string) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const printSettings = {
    id: 'settings_printer',
    label: LANG_TEXT.PRINTER_SETTINGS,
    icon: PrintIcon,
    path: `/astrolab-store/${restaurantId}/settings_printer`,
    enable: isNativeApp && isAstrolabStore,
  };

  return (
    <Drawer variant="permanent" open={open} sx={{ width: open ? 250 : 82 }}>
      <List component="nav" className={classes.ListMenu}>
        <Box className={`${classes.BoxMenu}`}>
          <UserInfoDisplay loading={loading} profilePic={currentSetting.restaurant_profile_pic} name={currentSetting.name} open={open} classes={classes} />

          <Box className={`${classes.BoxStyles}`}>
            {staffSidebarItems
              .map((i) => ({ ...i, path: `${isAstrolabStore ? '/astrolab-store' : '/food_trucks'}/${restaurantId}${i.path}`, enable: true }))
              .map((item) => (
                <SidebarItemComponent key={item.id} item={item} open={open} classes={classes} isExpanded={expandedItems[item.id]} toggleSubMenu={toggleSubMenu} />
              ))}
          </Box>
        </Box>
        <Box className={classes.BoxMenu}>
          <Box className={classes.BoxStyles}>
            <SidebarItemComponent
              key={printSettings.id}
              item={printSettings}
              open={open}
              classes={classes}
              isExpanded={expandedItems[printSettings.id]}
              toggleSubMenu={toggleSubMenu}
            />
          </Box>
        </Box>
      </List>
    </Drawer>
  );
}

const UserInfoDisplay = ({ loading, profilePic, name, open, classes }: { loading: boolean; profilePic: string; name: string; open: boolean; classes: any }) => {
  return (
    <Box className={classes.BoxImage}>
      {!loading && profilePic && <img src={`${profilePic}`} alt="profile" loading="lazy" className={classes.Logo} />}
      {open && (
        <Typography fontSize={14} lineHeight={'20px'} color={'var(--Primary-200, #C6ECCA)'}>
          {!loading && name}
        </Typography>
      )}
    </Box>
  );
};

export default FoodTruckSideBar;
